/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function GroupPropertiesEditViewController (this: JS5Object, _:JS5Object, $q: JS5Object, $routeParams: JS5Object, $route: JS5Object,
                                   $location: JS5Object, GroupsService: JS5Object, PermissionsService: JS5Object, uiGridConstants: JS5Object,
                                   ModalService: JS5Object, APPLICATION_STATE_LIST: JS5Object, PERMISSION_EXCEPTION_LIST: JS5Object,
                                   SidebarService: JS5Object, $timeout: JS5Function) {
    const defaultPermissionFlags: Array<string> = ['VIEW', 'MODIFY'];

    const createContentDataPermissions = (contentObjectClass: string) => {
        const existingPermissionContexts: JS5Object = this.editData.permissionContextMap;
        const mappingData: JS5Object = this.editData.mappingData;

        let newPermissions: Array<JS5Object> = [];
        let permissionContextMap: JS5Object = _.get(existingPermissionContexts, _.upperFirst(contentObjectClass));

        if (permissionContextMap) {
            _.forEach(permissionContextMap, (context: JS5Object) => {
                let newPermission: JS5Object = {
                    name: mappingData[contentObjectClass][context.target].name,
                    permissionContext: context
                };

                newPermissions.push(newPermission);
            });

            this.permissionGridContainers[contentObjectClass].gridOptions.data = newPermissions;
        }
    };

    const createPermissionContainer = (stateDisplayName: string, stateNameKey: string): JS5Object => {
        return {
            name: stateDisplayName,
            permissionContext: {
                target: 'Authorities',
                targetCriteria: `<and><condition property='${stateNameKey}' op='notnull'/></and>`,
                actions: []
            }
        };
    };

    const addChildPermissionContextExceptions = (newChildViewPermission: JS5Object, existingPermissionContextMap: JS5Object,
                                                 stateDisplayName: string, stateNameKey: string, ) => {

        if (_.get(PERMISSION_EXCEPTION_LIST, stateNameKey)) {
            newChildViewPermission.permissionContext.exceptions = [];
        }

        if (_.get(existingPermissionContextMap, stateNameKey)) {
            newChildViewPermission.name = stateDisplayName;

            newChildViewPermission.permissionContext = existingPermissionContextMap[stateNameKey];

            if (_.get(existingPermissionContextMap[stateNameKey], 'exceptions')) {
                let permissionExceptions: Array<JS5Object> = [];

                _.forEach(existingPermissionContextMap[stateNameKey].exceptions, (exception: JS5Object) => {
                    permissionExceptions.push({
                        permission: {
                            name: PERMISSION_EXCEPTION_LIST[stateNameKey].displayName,
                            permissionContext: existingPermissionContextMap[stateNameKey]
                        },
                        exception: exception
                    });
                });

                this.permissionGridContainers.exceptions.gridOptions.data = _.concat(this.permissionGridContainers.exceptions.gridOptions.data, permissionExceptions);
            }
        }
    };

    const createViewPermissions = () => {
        const existingPermissionContextMap: JS5Object = this.editData.permissionContextMap.Authorities;

        let newViewPermissionObject: JS5Object = {};

        _.forEach(APPLICATION_STATE_LIST, (stateGroup: JS5Object, key: string) => {

            _.forEach(stateGroup.parentViewStates, (stateDisplayName: string, stateNameKey: string) => {
                let newParentViewPermission: JS5Object = createPermissionContainer(stateDisplayName, stateNameKey);

                if (_.get(existingPermissionContextMap, stateNameKey)) {
                    newParentViewPermission.name = stateDisplayName;
                    newParentViewPermission.permissionContext = existingPermissionContextMap[stateNameKey];
                }

                if (!_.get(newViewPermissionObject, key)) {
                    newViewPermissionObject[key] = [];
                }

                newViewPermissionObject[key].push(newParentViewPermission);
            });

            _.forEach(stateGroup.childViewStates, (childStates: JS5Object, key: string) => {
                _.forEach(childStates, (stateDisplayName: string, stateNameKey: string) => {
                    let newChildViewPermission: JS5Object = createPermissionContainer(stateDisplayName, stateNameKey);

                    addChildPermissionContextExceptions(newChildViewPermission, existingPermissionContextMap, stateDisplayName, stateNameKey);

                    if (!_.get(newViewPermissionObject, key)) {
                        newViewPermissionObject[key] = [];
                    }

                    newViewPermissionObject[key].push(newChildViewPermission);
                });
            });
        });

        _.forEach(newViewPermissionObject, (viewPermissions: Array<JS5Object>, permissionsKey: string) => {
            this.permissionGridContainers[permissionsKey].gridOptions.data = viewPermissions;
        });
    };

    const getPermissionContextFromMap = (existingPermissionContextMap: JS5Object, targetClass: string, targetId: string) => {
        return _.get(existingPermissionContextMap, `[${targetClass}.null.${targetId}]`);
    };

    const createPermissionsFromMappingData = () => {
        const existingPermissionContexts = this.editData.permissionContextMap;
        const mappingData = this.editData.mappingData;

        createViewPermissions();

        // Iterate through the mapping data group keys: "network, packageCategoryType, longForm, shortForm" to
        // generate map/permissionContext objects in order to populate grids
        _.forEach(mappingData, (mappingObjectClassArray: Array<JS5Object>, targetClassKey: string) => {
            if (targetClassKey === 'series' ||
                targetClassKey === 'movie' ||
                targetClassKey === 'advertisement') {

                createContentDataPermissions(targetClassKey);
            } else {
                let targetClass = targetClassKey;
                let newPermissions: Array<JS5Object> = [];

                // Iterate through mappingObjectClassArray
                _.forEach(mappingObjectClassArray, (mappingClassObject: JS5Object) => {
                    let newPermission: JS5Object = {};
                    let existingPermissionContext = {};
                    let existingPermissionContextMap = {};

                    // Retrieve existing permission context if it exists
                    if (targetClassKey === 'longForm' || targetClassKey === 'shortForm') {
                        targetClass = 'PackageCategory';
                        existingPermissionContextMap = _.get(existingPermissionContexts, 'PackageCategory');
                        existingPermissionContext = getPermissionContextFromMap(existingPermissionContextMap, targetClass, mappingClassObject.id);
                    } else if (targetClassKey === 'longFormType' || targetClassKey === 'shortFormType') {
                        targetClass = 'PackageCategoryType';
                        existingPermissionContextMap = _.get(existingPermissionContexts, 'PackageCategoryType');
                        existingPermissionContext = getPermissionContextFromMap(existingPermissionContextMap, targetClass, mappingClassObject.id);
                    } else {
                        existingPermissionContextMap = _.get(existingPermissionContexts, _.upperFirst(targetClassKey));
                        existingPermissionContext = getPermissionContextFromMap(existingPermissionContextMap, _.upperFirst(targetClassKey), mappingClassObject.id);
                    }

                    // Create new permission and it's context
                    if (_.isUndefined(existingPermissionContext)) {
                        newPermission = {
                            name: mappingClassObject.name,
                            permissionContext: {
                                target: `[${_.upperFirst(targetClass)}.null.${mappingClassObject.id}]`,
                                actions: []
                            }
                        };

                        newPermissions.push(newPermission);
                    } else {
                        newPermission.name = mappingClassObject.name;
                        newPermission.permissionContext = existingPermissionContext;
                        newPermissions.push(newPermission);
                    }
                });

                // Add permissions to corresponding grid
                this.permissionGridContainers[_.lowerFirst(targetClassKey)].gridOptions.data = newPermissions;
            }
        });
    };

    const getContentType = (contentType: string) => {
        let contentTypeSubString = _.split(contentType.toLowerCase(), '/', 1)[0];

        if (contentTypeSubString === 'ad') {
            contentTypeSubString = 'advertisement';
        }

        return contentTypeSubString;
    };

    const createPermissionContext = (content: JS5Object) => {
        let newPermissionContext: JS5Object = {
            target: `[${_.upperFirst(getContentType(content.type))}.null.${content.id}]`,
            actions: defaultPermissionFlags
        };

        return newPermissionContext;
    };

    const contentSelectionHandler = (content: JS5Object) => {
        const newPermissionContext: JS5Object = createPermissionContext(content);
        this.permissionGridContainers[getContentType(content.type)].gridOptions.data.push({
            name: content.name,
            permissionContext: newPermissionContext
        });
        this.editData.permissionContexts.push(newPermissionContext);
        this.editorForm.$setDirty();
    };

    const revertPermissions = () => {
        this.editData.group = _.cloneDeep(GroupsService.originalEditData.group);
        this.editData.permissionContexts = _.cloneDeep(GroupsService.originalEditData.permissionContexts);

        _.forEach(this.permissionGridContainers, (gridContainer: JS5Object, gridContainerKey: string) => {
            _.forEach(this.originalPermissionGridContainers, (originalGridContainer: JS5Object, originalContainerKey: string) => {
                if (gridContainerKey === originalContainerKey) {
                    gridContainer.gridOptions.data = _.cloneDeep(originalGridContainer.gridOptions.data);
                }
            });
        });

        this.editorForm.$setPristine();
    };

    const getData = () => {
        this.loadingIndicator.show = true;
        $q.all([
            PermissionsService.isSystemOperator().then((isSystemOps: boolean) => {
                this.canWriteSystemOpsPermissions = isSystemOps;
            }),
            GroupsService.getGroupAndMappingData($routeParams.id).then((viewData: JS5Object) => {
                GroupsService.breadcrumbName = viewData.group.name;
                GroupsService.originalEditData = {
                    group: _.cloneDeep(viewData.group),
                    permissionContexts: _.cloneDeep(viewData.permissionContexts)
                };
                this.editData = viewData;

                createPermissionsFromMappingData();

                this.originalPermissionGridContainers = _.cloneDeep(this.permissionGridContainers);
            })
        ]).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const createOrUpdateData = () => {
        let isNew = _.toNumber($routeParams.id) === -1;
        let createOrUpdatePromise;
        this.loadingIndicator.show = true;

        if (isNew) {
            createOrUpdatePromise = GroupsService.createGroup(this.editData.group, this.editData.permissionContexts);
        } else {
            createOrUpdatePromise = GroupsService.updateGroup(this.editData.group, GroupsService.originalEditData.permissionContexts, this.editData.permissionContexts);
        }

        createOrUpdatePromise.then((viewData: JS5Object) => {
            GroupsService.originalEditData = _.cloneDeep(viewData);
            this.editData.group = viewData.group;
            this.editData.permissionContexts = viewData.permissionContexts;
            GroupsService.updateMappingData(this.editData);
            createPermissionsFromMappingData();
            this.originalPermissionGridContainers = _.cloneDeep(this.permissionGridContainers);
            $route.updateParams({id: this.editData.group.id});
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const columnDefinitionObject = {
        name: {
            displayName: 'Name',
            field: 'name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        read: {
            displayName: 'Read',
            field: 'permissionContext.actions',
            width: 120,
            cellTemplate: 'components/visual/grid/read-check-mark-template.html'
        },
        writeExecute: {
            displayName: 'Write/Execute',
            field: 'permissionContext.actions',
            width: 120,
            cellTemplate: 'components/visual/grid/write-execute-check-mark-template.html'
        },
        action: {
            displayName: '',
            field: 'permissionContext',
            width: 30,
            cellTemplate: 'components/visual/grid/exception-icon-template.html'
        },
        exceptions: [
            {
                displayName: 'Exception Type',
                field: 'permission.name',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                displayName: 'Content',
                field: 'exception.content.type',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
                width: 140
            },
            {
                displayName: 'Series/Movie',
                field: 'exception.content.name',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                displayName: 'Categories',
                field: 'exception.categories',
                cellFilter: 'arrayToCsv',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
                width: 300
            },
            {
                displayName: 'Offset',
                field: 'exception.proxyReleaseOffsetInMinutes',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
                width: 60
            },
            {
                displayName: '',
                field: 'edit',
                width: 30,
                cellTemplate: 'components/visual/grid/exception-icon-template.html'
            },
            {
                displayName: '',
                field: 'remove',
                width: 30,
                cellTemplate: 'components/visual/grid/exception-icon-template.html'
            }
        ]
    };

    const getGridOptions = (targetClassName: string, columnDefinitionKeys: Array<string>): JS5Object => {
        return {
            rowSelection: false,
            enableRowHeaderSelection: false,
            enableSelectAll: false,
            enableColumnResizing: true,
            enablePaginationControls: false,
            enableSorting: true,
            enableColumnMenus: false,
            enableFullRowSelection: true,
            enableHorizontalScrollbar: uiGridConstants.ALWAYS,
            enableVerticalScrollbar: uiGridConstants.ALWAYS,
            rowHeight: 26,
            multiSelect: false,
            columnDefs: _.chain(_.cloneDeep(columnDefinitionObject)).pick(columnDefinitionKeys).toArray().flatten().value(),
            onRegisterApi: (gridApi: JS5Object) => {
                this.permissionGridContainers[targetClassName]['gridApi'] = gridApi;
            },
            data: []
        };
    };

    const exceptionCloseHandler = (exceptionData: JS5Object) => {
        if (!exceptionData.isEdit) {
            exceptionData.exceptionPermission.permission.permissionContext.exceptions.push(exceptionData.exceptionPermission.exception);
            this.permissionGridContainers.exceptions.gridOptions.data.push(exceptionData.exceptionPermission);
        } else {
            _.forEach(this.editData.permissionContexts, (context: JS5Object) => {
                if (context.targetCriteria === exceptionData.exceptionPermission.permission.permissionContext.targetCriteria) {
                    context.exceptions = exceptionData.exceptionPermission.permission.permissionContext.exceptions;
                }
            });
        }
        this.editorForm.$setDirty();
    };

    const isReadColumn = (column: JS5Object) => {
        return _.split(column.displayName, '/')[0] === 'Read'
    };

    const calculateNewRowActions = (toggledRow: JS5Object, toggledColumn: JS5Object) => {
        let permission: JS5Object = toggledRow.entity;
        let isViewPermission: boolean = _.get(permission.permissionContext, 'target') === 'Authorities';
        let selectionMap: JS5Object = {
            readOnly: ['READ'],
            readWrite: ['READ', 'WRITE'],
            writeExecute: ['VIEW', 'MODIFY'],
            noPermissions: []
        };
        let newActions: string[];

        if (isViewPermission) {
            let readToggled = isReadColumn(toggledColumn);
            if (readToggled) {
                let hadReadAction = _.difference(selectionMap.readOnly, permission.permissionContext.actions).length === 0;
                newActions = (hadReadAction) ? selectionMap.noPermissions : selectionMap.readOnly;
            } else { // Write/Execute toggled
                let readColumnVisible = _.some(toggledRow.grid.columns, isReadColumn);
                let hadWriteAction = _.difference(selectionMap.readWrite, permission.permissionContext.actions).length === 0;
                if (!hadWriteAction) {
                    newActions = selectionMap.readWrite;
                } else {
                    newActions = (readColumnVisible) ? selectionMap.readOnly : selectionMap.noPermissions;
                }
            }

        } else {
            let hadActions = !_.isEqual(selectionMap.noPermissions, permission.permissionContext.actions);
            newActions = (hadActions) ? selectionMap.noPermissions : selectionMap.writeExecute;
        }
        return newActions;
    }

    const updatePermission = (prevPermission: JS5Object, newActions: string[]) => {
        let prevHadActions = !_.isEmpty(prevPermission.permissionContext.actions);
        let nowHasActions = !_.isEmpty(newActions);

        prevPermission.permissionContext.actions = newActions;
        if (!prevHadActions && nowHasActions) {
            this.editData.permissionContexts.push(prevPermission.permissionContext);
        } else if (prevHadActions && !nowHasActions) {
            _.remove(this.editData.permissionContexts, (groupContext: JS5Object) => {
                let isViewPermission: boolean = _.get(prevPermission.permissionContext, 'target') === 'Authorities';
                if (isViewPermission) {
                    return _.get(groupContext, 'targetCriteria') &&
                        GroupsService.XJS.xml2js(prevPermission.permissionContext.targetCriteria).and.condition._property === GroupsService.XJS.xml2js(groupContext.targetCriteria).and.condition._property;
                } else {
                    return prevPermission.permissionContext.target === groupContext.target;
                }
            });
        }
    };

    this.checkMarkCellClicked = (row: JS5Object, column: JS5Object) => {
        let impliedPermission: boolean = _.includes(this.permissionGridContainers.impliedSystemOps.gridOptions.data, row.entity);
        if (impliedPermission) {
            return;
        }

        let newActions = calculateNewRowActions(row, column);
        updatePermission(row.entity, newActions);

        let isSystemOpsPermission: boolean = _.includes(this.permissionGridContainers.systemOps.gridOptions.data, row.entity);
        if (isSystemOpsPermission) {
            _.forEach(this.permissionGridContainers.impliedSystemOps.gridOptions.data, (impliedPermission: JS5Object) => {
                updatePermission(impliedPermission, newActions);
            });
        }
        this.editorForm.$setDirty();
    };

    this.exceptionCellClickHandler = (row: JS5Object, column: JS5Object, index: JS5Object, event: JS5Object) => {
        let addException = column.field === 'permissionContext';

        if (addException && row.entity.permissionContext.actions.length === 0) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }

        if (column.field === 'remove') {
            _.remove(row.entity.permission.permissionContext.exceptions, (existingException: JS5Object) => {
                return _.isEqual(row.entity.exception, existingException) ||
                       _.get(row.entity.exception, 'id') === _.get(existingException, 'id');
            });
            _.pullAt(this.permissionGridContainers.exceptions.gridOptions.data, index);
            this.editorForm.$setDirty();
        } else {
            let isEdit = column.field === 'edit';
            let series = _.toArray(this.editData.mappingData.series);
            let movies = _.toArray(this.editData.mappingData.movie);
            let categories = _.toArray(_.concat(this.editData.mappingData.shortForm, this.editData.mappingData.longForm));
            let permissionException = {
                permission: row.entity,
                exception: {}
            };

            if (isEdit) {
                const proxyReleaseOffsetInMinutes = _.toNumber(_.get(row.entity.exception, 'proxyReleaseOffsetInMinutes'));
                row.entity.exception.proxyReleaseOffsetInMinutes = _.isNaN(proxyReleaseOffsetInMinutes) ? undefined : proxyReleaseOffsetInMinutes;
                permissionException = row.entity;
            }

            ModalService.showGroupsExceptionModal(series, movies, categories, permissionException, isEdit, exceptionCloseHandler);
        }
    };

    this.permissionGridContainers = {
        network: {
            displayName: 'Networks',
            gridOptions: getGridOptions('network', ['name', 'writeExecute'])
        },
        longFormType: {
            displayName: 'Long Form',
            gridOptions: getGridOptions('longFormType', ['name', 'writeExecute'])
        },
        shortFormType: {
            displayName: 'Short Form',
            gridOptions: getGridOptions('shortFormType', ['name', 'writeExecute'])
        },
        longForm: {
            targetClass: 'PackageCategory',
            gridOptions: getGridOptions('longForm', ['name', 'writeExecute'])
        },
        shortForm: {
            targetClass: 'PackageCategory',
            gridOptions: getGridOptions('shortForm', ['name', 'writeExecute'])
        },
        series: {
            displayName: 'Series',
            gridOptions: getGridOptions('series', ['name'])
        },
        movie: {
            displayName: 'Movies/Specials',
            gridOptions: getGridOptions('movie', ['name'])
        },
        advertisement: {
            displayName: 'Ads',
            gridOptions: getGridOptions('advertisement', ['name'])
        },
        dashboard: {
            displayName: 'Dashboard',
            gridOptions: getGridOptions('dashboard', ['name', 'read', 'writeExecute'])
        },
        meta: {
            displayName: 'Meta',
            gridOptions: getGridOptions('meta', ['name', 'read', 'writeExecute'])
        },
        metaNetwork: {
            displayName: 'Networks',
            gridOptions: getGridOptions('metaNetwork', ['name', 'read', 'writeExecute'])
        },
        metaSeries: {
            displayName: 'Series',
            gridOptions: getGridOptions('metaSeries', ['name', 'read', 'writeExecute'])
        },
        metaMovie: {
            displayName: 'Movies',
            gridOptions: getGridOptions('metaMovie', ['name', 'read', 'writeExecute'])
        },
        packages: {
            displayName: 'Package',
            gridOptions: getGridOptions('packages', ['name', 'read', 'writeExecute'])
        },
        packageAction: {
            displayName: 'Package',
            gridOptions: getGridOptions('packageAction', ['name', 'read', 'writeExecute', 'action'])
        },
        packageBasic: {
            displayName: 'Package',
            gridOptions: getGridOptions('packageBasic', ['name', 'read', 'writeExecute'])
        },
        packageActionClip: {
            displayName: 'Package',
            gridOptions: getGridOptions('packageActionClip', ['name', 'read', 'writeExecute', 'action'])
        },
        packageClip: {
            displayName: 'Package',
            gridOptions: getGridOptions('packageBasic', ['name', 'read', 'writeExecute'])
        },
        aggregationSetup: {
            displayName: 'Aggregation',
            gridOptions: getGridOptions('aggregationSetup', ['name', 'read', 'writeExecute'])
        },
        system: {
            displayName: 'System',
            gridOptions: getGridOptions('system', ['name', 'read', 'writeExecute'])
        },
        systemPartner: {
            displayName: 'Partners',
            gridOptions: getGridOptions('systemPartner', ['name', 'read', 'writeExecute'])
        },
        systemOps: {
            displayName: 'System Operations',
            gridOptions: getGridOptions('systemOps', ['name', 'writeExecute'])
        },
        impliedSystemOps: {
            displayName: 'System Operations - Implied',
            gridOptions: getGridOptions('impliedSystemOps', ['name', 'writeExecute'])
        },
        exceptions: {
            displayName: 'Exceptions',
            gridOptions: getGridOptions('exceptions', ['exceptions'])
        }
    };

    this.addContent = (contentType: string) => {
        const formattedContentType = getContentType(contentType);
        const filteredContent = _.filter(this.editData.mappingData[formattedContentType], (content: JS5Object) => {
            return !_.find(this.permissionGridContainers[formattedContentType].gridOptions.data, (permission: JS5Object) => permission.permissionContext.target.endsWith(`${content.id}]`));
        });

        ModalService.showContentSelectModal(contentType, filteredContent, contentSelectionHandler);
    };

    this.removeGridContentAndPermissionContext = (contentType: string) => {
        const permissionGridContainer = this.permissionGridContainers[getContentType(contentType)];
        const selectedRow = permissionGridContainer.gridApi.selection.getSelectedRows()[0];
        _.remove(permissionGridContainer.gridOptions.data, (permission: JS5Object) => permission.permissionContext.target === selectedRow.permissionContext.target);
        _.remove(this.editData.permissionContexts, (permissionContext: JS5Object) => permissionContext.target === selectedRow.permissionContext.target);
        this.editorForm.$setDirty();
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine') && !!_.get(this.editData.group, 'name'),
            onClick: createOrUpdateData
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                revertPermissions();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url($route.current.rootRoute)
        }
    ];

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
            getData();
        } else {
            $location.url('/login');
        }
    };

    this.$postLink = function () {
        $timeout(() => {
            GroupsService.editorForm = this.editorForm;
            SidebarService.editService = GroupsService;
        });
    };

    this.$onDestroy = () => {
        GroupsService.breadcrumbName = undefined;
        GroupsService.originalEditData = undefined;
        GroupsService.editorForm = undefined;
    };
}

angular.module('prism-ui.groups').component('groupPropertiesEditView', {
    templateUrl: 'system/groups/editor/properties/group-properties-edit-view-template.html',
    controller: GroupPropertiesEditViewController,
    bindings: {
        isAdmin: '<'
    }
})
.filter('arrayToCsv', () => {
    return (array: JS5Object) => {
        return _.chain(array).map('name').value().join(', ');
    }
});
